<div *ngIf="isLoading">
  <div class="text-center">
    <ap-spinner size="2"></ap-spinner>
  </div>
</div>

<div *ngIf="!isLoading" class="content-information-tab" [formGroup]="informationTabFormGroup">
  <div class="form-group" #findControlIdRef>
    <label for="{{baseId}}-id" translate>ID</label>
    <input id="{{baseId}}-id"
            class="form-control"
            [ngClass]="{'error': externalIdFormControl.invalid && form.submitted}"
            type="text"
            maxlength="25"
            formControlName="externalIdFormControl"
            (paste)="false" />
    <ng-container *ngIf="form.submitted && externalIdFormControl && externalIdFormControl.hasError('maxlength')">
      <div id="{{baseId}}-warning-text-external-id-maxlength" class="incorrect-input" translate>
        External Id must be 25 characters or less.
      </div>
    </ng-container>
  </div>

  <div class="form-group" #findControlNameRef>
    <label for="{{baseId}}-name" translate>Name</label>
    <input id="{{baseId}}-name"
            class="form-control"
            [ngClass]="{'error': nameFormControl.invalid && form.submitted}"
            type="text"
            maxlength="50"
            formControlName="nameFormControl"
            (paste)="false" />
    <ng-container *ngIf="form.submitted && nameFormControl && nameFormControl.hasError('maxlength')">
      <div id="{{baseId}}-warning-text-name-maxlength" class="incorrect-input" translate>
        Name must be 50 characters or less.
      </div>
    </ng-container>
    <ng-container *ngIf="form.submitted && nameFormControl && nameFormControl.hasError('required')">
      <div id="{{baseId}}-warning-text-name-required" class="incorrect-input" translate>
        Name is a required input.
      </div>
    </ng-container>
  </div>

  <div class="form-group" #findControlLicenseCodeRef>
    <label for="{{baseId}}-license-code" translate>License Code</label>
    <input id="{{baseId}}-license-code"
            class="form-control"
            [ngClass]="{'error': licenseCodeFormControl.invalid && form.submitted}"
            type="text"
            maxlength="50"
            formControlName="licenseCodeFormControl"
            (paste)="false" />
    <ng-container *ngIf="form.submitted && licenseCodeFormControl && licenseCodeFormControl.hasError('maxlength')">
      <div id="{{baseId}}-warning-text-license-code-maxlength" class="incorrect-input" translate>
        License code must be 50 characters or less.
      </div>
    </ng-container>
  </div>

  <div class="form-group" id="{{baseId}}-security-group" #findControlSecurityGroupRef>
    <label translate>Security Group</label>
    <ap-findcontrol [baseId]="baseId + '-find-security-group'"
                    [(selectedPk)]="securityGroupUid"
                    [findControlDisplayName]="'Security Group'"
                    [findControlId]="findControlIdService.ListSecurityGroup"
                    [apFormGroup]="informationTabFormGroup"
                    [controlName]="'securityGroupFormControl'"
                    [singleSelect]="true"
                    [disabled]="isSystemDefinedFindControl"
                    [form]="form"
                    [disabled]="!findControlBehavior.UserDefined">
    </ap-findcontrol>
  </div>

  <div class="form-group" #findControlFindTableNameRef>
    <label for="{{baseId}}-find-table-name" translate>Find Table Name</label>
    <input id="{{baseId}}-find-table-name"
            class="form-control"
            [ngClass]="{'error': findTableNameFormControl.invalid && form.submitted}"
            type="text"
            maxlength="50"
            formControlName="findTableNameFormControl"
            (paste)="false" />
    <ng-container *ngIf="form.submitted && findTableNameFormControl && findTableNameFormControl.hasError('maxlength')">
      <div id="{{baseId}}-warning-text-find-table-name-maxlength" class="incorrect-input" translate>
        Find Table Name must be 50 characters or less.
      </div>
    </ng-container>
    <ng-container *ngIf="form.submitted && findTableNameFormControl && findTableNameFormControl.hasError('required')">
      <div id="{{baseId}}-warning-text-find-table-name-required" class="incorrect-input" translate>
        Find table name is a required input.
      </div>
    </ng-container>
  </div>

  <div class="form-group" id="{{baseId}}-add-in">
    <label translate>Find AddIn</label>
    <ap-findcontrol [baseId]="baseId + '-find-add-in'"
                    [(selectedPk)]="addInUid"
                    [findControlId]="findControlIdService.ListAddIn"
                    [singleSelect]="true"
                    [disabled]="isSystemDefinedFindControl">
    </ap-findcontrol>
  </div>

  <div class="checkbox-group">
    <mat-checkbox id="{{baseId}}-inactive-checkbox"
                  formControlName="inactiveFormControl"
                  translate>Inactive
    </mat-checkbox>
    <mat-checkbox id="{{baseId}}-user-defined-checkbox"
                  formControlName="userDefinedFormControl"
                  translate>User Defined
    </mat-checkbox>
  </div>

  <div class="form-group full-control">
    <hr class="emds-hr hr-thin-grey">
  </div>

  <div class="form-group full-control prepopulate-options-control">
    <div class="prepopulate-options-label" translate>Prepopulation Options</div>
    <mat-radio-group class="radio-group" name="prepopulateOptionsRadioGroup"
                      formControlName="prepopulateOptionsFormControl">
      <mat-radio-button id="{{baseId}}-none-radiobutton"
                        [value]="'None'"
                        translate>None
      </mat-radio-button>
      <mat-radio-button id="{{baseId}}-all-radiobutton"
                        [value]="'All'"
                        translate>All
      </mat-radio-button>
      <mat-radio-button id="{{baseId}}-mru-radiobutton"
                        [value]="'MRU'"
                        translate>Most Recently Used
      </mat-radio-button>
      <mat-radio-button id="{{baseId}}-mfu-frequency-radiobutton"
                        [value]="'MFU_Frequency'"
                        translate>Most Frequently Used (Frequency)
      </mat-radio-button>
      <mat-radio-button id="{{baseId}}-mfu-alpha-radiobutton"
                        [value]="'MFU_Alpha'"
                        translate>Most Frequently Used (Alphabetical)
      </mat-radio-button>
    </mat-radio-group>
  </div>

  <div class="form-group max-items-control" id="{{baseId}}-max-items-returned" #numericUpDownRef>
    <label translate>Maximum Items Returned (-1 for no limit)</label>
    <ap-numeric-up-down
      [baseId]="baseId"
      [initialValue]="findControlBehavior.MaxRows"
      [minValue]="-1"
      [maxValue]="10000"
      [required]="true"
      [currentValueFormControl]="maxRowsFormControl"
      [form]="form">
    </ap-numeric-up-down>
  </div>

  <div class="form-group full-control">
    <hr class="emds-hr hr-thin-grey">
  </div>

  <div class="form-group full-control" #findControlNotesRef>
    <label for="{{baseId}}-notes" translate>Notes</label>
    <textarea class="form-control"
              [ngClass]="{'error': notesFormControl.invalid && form.submitted}"
              id="{{baseId}}-notes"
              formControlName="notesFormControl"
              (paste)="false"
              rows="3">
    </textarea>
  </div>

  <div class="form-group full-control" #findControlColumnsRef>
    <label for="{{baseId}}-columns" translate>Columns</label>
    <textarea class="form-control"
              id="{{baseId}}-columns"
              formControlName="columnsConfigFormControl"
              (paste)="false"
              rows="5">
    </textarea>
  </div>
</div>
